/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useDatasetImportsTableStyles = makeStyles({
  container: {
    // maxWidth: "870px",
    position: 'relative',
  },
  root: {
    marginBottom: '14px',
    width: '100%',
  },
  nameCell: {
    // width: "42%",
  },
  databaseInput: {
    width: '100%',
    maxWidth: '300px',
    marginBottom: '15px',
  },
});
